export default __webpack_public_path__ + "static/media/revenue.2bb3da40.png";